// HistoryModifier.js
import withRouter from '../component/WithRouter.jsx';
import { connect } from 'react-redux';
import postMessageToSwagApp from '../action/postMessageToSwagApp.js';
import getRouteHistory from '../selector/getRouteHistory.js';
import HistoryModifier from '../component/HistoryModifier.jsx';

const mapStateToProps = (state, { location: { pathname, search } }) => {
  return {
    pathname,
    route: `${pathname}${search}`,
    previousRoute: getRouteHistory(state, 'previousRoute'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    closeInappWebView: () =>
      dispatch(postMessageToSwagApp({ message: 'closeWebView' })),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HistoryModifier)
);
